import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import EventTableMui from "./event-table-mui";

import { allData as allDataFn } from "./trend-graph-utils";

const TrendMetaData = loader("../graphql/TrendMetaData.graphql");

const TrendEventValues = loader("../graphql/TrendEventValues.graphql");

interface Props {
  nodes?: any[];
  panelId?: string;
  startDate: number; // Date;
  endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

// FIXME Use paginated datasource, not the one for charts!
function EventTableContainer(props: Props) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    // nodes,
    panelId,
    startDate,
    endDate,
    widgetStatic,
    widgetTitle,
  } = props;
  const { data, error: metaError, loading: metaLoading } = useQuery(
    TrendMetaData,
    {
      variables: { panel: panelId },
    }
  );
  const {
    data: dataSeries,
    error: valuesError,
    loading: valuesLoading,
  } = useQuery(TrendEventValues, {
    variables: { panel: panelId, startDate, endDate },
  });
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  if (valuesLoading) {
    return <div>Loading...</div>;
  }
  if (valuesError) {
    console.error(valuesError.message);
    return <div>Error! {valuesError.message}</div>;
  }

  const allData = allDataFn(data.metaData);
  const chartData =
    dataSeries &&
    dataSeries.dataSeries &&
    dataSeries.dataSeries[0] &&
    dataSeries.dataSeries[0].data
      ? dataSeries.dataSeries[0].data
          .map((s: any[]) => ({
            time: s[0],
            duration: s[1],
            message: s[2],
            imageKey: s[3],
            tagId: s[4],
            eventId: s[5],
            isAcknowledged: s[6],
            iconFileName: s[7],
          }))
          .sort((a: any, b: any) => b.time - a.time) // TODO remove sorting (should be done on server)
      : [];
  return (
    <EventTableMui
      // nodes={nodes}
      allData={allData}
      metaData={data.metaData}
      chartData={chartData}
      dataSeries={dataSeries.dataSeries}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
    />
  );
}

export default EventTableContainer;
